const n = "_pagination__pageButton_2sdxl_1", t = "_pagination__chevronButton_2sdxl_41", o = {
  pagination__pageButton: n,
  pagination__chevronButton: t
};
export {
  o as s
};
